/* eslint no-param-reassign: ["error", { "props": false }] */
import debounce from 'lodash/debounce';
import './accordion';
import setupLazyLoadingAndAnimations from './lazy_loading';
import setupCompatibilityClasses from './compatibility';

function setupDesktopMenu() {
  const navbar = document.getElementById('gusto-navbar');
  const PAGE_OFFSET = 75;
  let closeTimer;
  let openTimer;

  const updateWithinPageClass = () => {
    const hasWithinPageClass = navbar.classList.contains('on-scroll');
    if (window.pageYOffset > PAGE_OFFSET && !hasWithinPageClass) {
      navbar.classList.add('on-scroll');
    }
    if (window.pageYOffset <= PAGE_OFFSET && hasWithinPageClass) {
      navbar.classList.remove('on-scroll');
    }
  };
  const closeMenuDropdowns = () => {
    Array.from(document.querySelectorAll('nav .accordion-js .checked')).forEach(label => {
      label.classList.remove('checked');
      label.querySelector('input').checked = false;
      label.querySelector('.menu-item-with-dropdown').setAttribute('aria-expanded', false);
    });
  };
  const closeMenuOnOutsideClick = event => {
    const openMenu = document.querySelector('nav .accordion-js input:checked');
    if (!openMenu) return;

    if (event.target.closest('nav') === null) {
      closeMenuDropdowns();
    }
  };
  const openMenuDropdown = event => {
    const input = event.target.parentElement.querySelector('input');
    if (input.checked) return;

    closeMenuDropdowns();
    input.checked = true;
    event.target.setAttribute('aria-expanded', true);
    event.target.parentElement.classList.toggle('checked');
  };

  const clearCloseTimer = () => {
    clearTimeout(closeTimer);
  };

  const clearOpenTimer = () => {
    clearTimeout(openTimer);
  };

  const startCloseTimer = () => {
    clearOpenTimer();
    closeTimer = setTimeout(closeMenuDropdowns, 200);
  };

  const startOpenTimer = event => {
    openTimer = setTimeout(() => {
      openMenuDropdown(event);
    }, 75);
    clearCloseTimer();
  };

  const isHoveringButtons = () => {
    document.querySelector('.menu-content').classList.add('button-hover');
  };

  const notHoveringButtons = () => {
    document.querySelector('.menu-content').classList.remove('button-hover');
  };

  document.addEventListener('scroll', () => {
    updateWithinPageClass();
    closeMenuDropdowns();
  });

  const menuTitles = Array.from(document.querySelectorAll('nav .menu-item-with-dropdown'));
  menuTitles.forEach(title => {
    title.addEventListener('mouseenter', startOpenTimer);
    title.addEventListener('click', () => false);
    title.addEventListener('mouseleave', startCloseTimer);
  });

  document.addEventListener('click', closeMenuOnOutsideClick);

  const menuContent = Array.from(document.querySelectorAll('.menu-content'));
  menuContent.forEach(mc => {
    mc.addEventListener('mouseenter', clearCloseTimer);
    mc.addEventListener('mouseleave', startCloseTimer);
    mc.addEventListener('click', closeMenuDropdowns);
  });

  const subMenuButtons = Array.from(document.querySelectorAll('.subnav-buttons'));
  subMenuButtons.forEach(button => {
    button.addEventListener('mouseenter', isHoveringButtons);
    button.addEventListener('mouseleave', notHoveringButtons);
  });

  // Make sure subnav is not closing for accountants and resources
  [
    document.querySelector('.menu-content-accountants'),
    document.querySelector('.menu-content-resources'),
  ].forEach(selector => {
    if (selector) {
      selector.addEventListener('mouseenter', clearCloseTimer);
      selector.addEventListener('mouseleave', startCloseTimer);
      selector.addEventListener('click', closeMenuDropdowns);
    }
  });

  updateWithinPageClass();
}

function setupMobileMenu() {
  const html = document.querySelector('html');
  const burgerColumn = document.getElementById('gusto-burger-col');
  const searchButton = document.getElementById('site-search');
  const mobileNavBarToggle = document.getElementById('mobile-navbar-toggle');

  burgerColumn.addEventListener('click', () => {
    html.classList.toggle('freezePage');
  });

  if (searchButton) {
    searchButton.addEventListener('click', () => {
      if (mobileNavBarToggle.checked) {
        mobileNavBarToggle.checked = false;
      }
    });
  }
}

function updateNavbarUndersideMargin() {
  const navbarHeight = document.getElementById('gusto-navbar').clientHeight;
  const navbarUnderside = document.querySelector('.navbar-underside');
  navbarUnderside.style.marginBottom = `${navbarHeight}px`;
}

// This custom events comes from referral.js to listen for when the notification banner is showing/hiding
window.addEventListener('referral-bar-change', () => {
  updateNavbarUndersideMargin();
});

// This custom events comes from notification_bar.js to listen for when the notification banner is showing/hiding
window.addEventListener('notification-bar-change', () => {
  updateNavbarUndersideMargin();
});

// This is updating the margin-bottom on resize with debouce to not have it run all the time
window.addEventListener('resize', debounce(updateNavbarUndersideMargin, 200));

window.addEventListener(
  'load',
  () => {
    setupCompatibilityClasses();
    setupDesktopMenu();
    setupMobileMenu();
    setupLazyLoadingAndAnimations();
  },
  { once: true }
);
